import { jsx } from "@emotion/react/jsx-runtime";
import ReactIntlProvider from "./auth-service-tools16.js";
import { SHARED_COMPONENTS_EN_US } from "./auth-service-tools17.js";

const IntlProvider = (_ref) => {
  let {
    locale,
    children
  } = _ref;
  return /* @__PURE__ */jsx(ReactIntlProvider, {
    locale,
    messages: SHARED_COMPONENTS_EN_US,
    children
  });
};

export { IntlProvider };